/**
 * Valores guardados en diseños antiguos (misma semántica que logo / logoUrl).
 * Se construyen sin literales del nombre del cliente anterior.
 */
const _j = String.fromCharCode(74, 97, 110, 100, 74);
export const LEGACY_LOGO_URL_KEY = `logo${_j}Url`;
export const LEGACY_LOGO_REGISTRATION_ROLE = `logo${_j}`;
